export const GALLERY_SEARCH_EVENT = 'filterable-gallery-search';
